// extracted by css-extract-rspack-plugin
export default {"table":"_237Jq"};